// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2TiHj","content":"GlobalSearch_content__2lVTJ"};